import dayjs from 'dayjs';

export const shortenNumber = (value?: number, roundOff?: boolean, shortenAbove?: number) => {
  const units = ['K', 'M', 'B', 'T'];
  const adjustedValue = roundOff ? Math.round(value ?? 0) : value ?? 0;

  if (shortenAbove !== undefined && adjustedValue < shortenAbove) {
    if (roundOff) {
      return Math.round(value ?? 0).toString();
    }
    return (value ?? 0).toString();
  }

  for (let i = units.length - 1; i >= 0; i--) {
    const decimal = 1000 ** (i + 1);
    if (adjustedValue >= decimal) {
      const valueMod = (value ?? 0) / decimal;
      if (roundOff) {
        return +Math.round(valueMod) + units[i];
      }

      return +valueMod.toFixed(1) + units[i];
    }
  }

  if (roundOff) {
    return Math.round(value ?? 0).toString();
  }

  return (value ?? 0).toString();
};

export const currency = (value?: number, options?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat('en-US', {
    currency: 'USD',
    maximumFractionDigits: 0,
    style: 'currency',
    ...options,
  }).format(value ?? 0);

export const shortenCurrency = (value?: number, roundOff?: boolean) => `$${shortenNumber(value ?? 0, roundOff)}`;

export const date = (value?: string, withoutYear?: boolean) =>
  value ? dayjs(value).format(withoutYear ? 'MMM DD' : 'MMM DD, YYYY') : '-';

export const percent = (value?: number, doNotRound?: boolean) => {
  const numericValue = value ?? 0;

  if (doNotRound) {
    const rawPercent = numericValue * 100;
    const fixedString = rawPercent.toFixed(2);

    // Regex to strip trailing zeros and decimal point if they follow only zeros.
    const finalString = fixedString.replace(/\.00$|(\.\d*?[1-9])0+$/, '$1');
    return `${finalString}%`;
  } else {
    return `${Math.round(numericValue * 100)}%`;
  }
};

export const appendPercent = (value?: number) => `${Math.round(value ?? 0)}%`;

export const value = (value?: number) => new Intl.NumberFormat('en-US').format(value ?? 0);
